import PropTypes from 'prop-types'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { Button, Box } from '@mui/material'
import { STEPS } from '../../../common/constants'
import useTranslations from '../../../i18n/useTranslations'
import useStyles from './styles'

const ActionButtons = ({
  isPrimaryDisabled,
  isDirty,
  isSaved,
  onCancel,
  hasOtherError,
  hasServerError,
  activeStep,
  currentStep,
  isSubmitting,
  isOriginPickupPoint,
}) => {
  const t = useTranslations()
  const classes = useStyles()

  const getSubmitButtonText = () => {
    if (!isSaved) {
      if (isOriginPickupPoint && currentStep === 'summary') {
        return t('action:submit-summary-origin-pickup-point')
      }
      return t(`action:submit-${currentStep}`)
    }
    if (isDirty || hasServerError) {
      return t('action:save-changes')
    }
    if (hasOtherError) {
      return t('action:go-to-next-error')
    }
    return t(`shipping-send-form:action:back-${activeStep}`)
  }

  return (
    <Box className={classes.actionButtons}>
      {/* Secondary action */}
      <Button
        className={classes.actionButton}
        type="button"
        variant="outlined"
        onClick={onCancel}
      >
        {t('action:cancel')}
      </Button>

      {/* Primary action */}
      <Button
        className={classes.actionButton}
        type="submit"
        disabled={isSubmitting || isPrimaryDisabled}
        endIcon={<ArrowRight />}
      >
        {getSubmitButtonText()}
      </Button>
    </Box>
  )
}

ActionButtons.propTypes = {
  isPrimaryDisabled: PropTypes.bool,
  isDirty: PropTypes.bool,
  isSaved: PropTypes.bool,
  onCancel: PropTypes.func,
  hasOtherError: PropTypes.bool,
  hasServerError: PropTypes.bool,
  activeStep: PropTypes.oneOf(Object.values(STEPS)),
  currentStep: PropTypes.oneOf(Object.values(STEPS)).isRequired,
  isSubmitting: PropTypes.bool,
  isOriginPickupPoint: PropTypes.bool,
}

export default ActionButtons
